module.exports = __webpack_public_path__ + "img/rose.96a8678b.png";